import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiHttpResponse } from "@kinomap-dev/ng-ui-lib";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment.local";

@Injectable({
    providedIn: 'root'
})

export class RecommendedService {
    constructor(
        private http: HttpClient
    ) { }

    getRecommended(type: string, sport?: string, machineType?: string, locale?: string): Observable<any> {
        if (type === 'mapmode') type = 'gpsOnly'
        let params: HttpParams = new HttpParams();
        switch (type) {
            case 'scenic':
                params = params.set("sport", sport)
                break
            case 'workout':
                params = params.set("sport", sport)
                    .set('machineType', machineType)
                break
            case 'coaching':
                params = params.set("sport", sport)
                    .set('_locale', locale)
                break
            default:
                break;
        }
        const url: string = `${environment.api.recommended.replace('{type}', type)}`;
        return this.http.get<ApiHttpResponse<any>>(url, { params }).pipe(
            map((response: ApiHttpResponse<any>) => response.data)
        )
    }
}